/**
 * Functions to get Intercom configuration
 * Contains defaults, which are overridden via environment variables.
 *
 * Functions are used instead of constants to allow potential for runtime changes.
 */
export default {
  appId: () => process.env.INTERCOM_APP_ID ?? 'e7znkyvh',
};
